/** Türkiye'de Rotary — görsel kaynağı. Metinler i18n: `rotaryTurkey.*`. */
export const ROTARY_TURKEY_IMAGE_SRC =
    'https://images.unsplash.com/photo-1589561454226-796a8aa89b05?auto=format&fit=crop&w=1200&q=80';
